import { useContext } from 'react';
import { ModalsContext } from '~/contexts/modals.context';

export default function useModals() {
  return useContext(ModalsContext);
}
